'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { SearchBox, useSearchBox } from 'react-instantsearch';
import { debounce } from 'lodash';
import avo from 'analytics/avo';
import { ALGOLIA_INDEX_NAME, DEFAULT_SEARCH_PLACEHOLDER, SEARCH_STATE_UPDATE_DEBOUNCE_MS, SEARCH_INPUT_MAX_LENGTH, ALL_FACETS_FILTER } from 'commons/constants';
import useIsBrowser from 'hooks/useIsBrowser';
import isClient from 'commons/isClient';
import IconSearch from 'components/icons/IconSearch';
import IconClose from 'components/icons/iconClose';
import useScreen from 'hooks/useScreen';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from '../../../commons/helpers';
import getQuickLinkMatch from '../QuickLinkDialog/getQuickLinkMatch';
const JBSearchBoxNext = t0 => {
  const $ = _c(76);
  let advanced;
  let forPage;
  let handleSearchBarFocus;
  let index;
  let initialQueryValue;
  let isActive;
  let otherProps;
  let setSearchStateQuery;
  let t1;
  let t2;
  let toggleMobileSearchBar;
  let variant;
  if ($[0] !== t0) {
    const {
      advanced: t3,
      autoFocus,
      defaultRefinement,
      forPage: t4,
      index: t5,
      inMobileNav: t6,
      isActive: t7,
      placeholder: t8,
      setInactive,
      variant: t9,
      initialQueryValue: t10,
      setSearchStateQuery: t11,
      toggleMobileSearchBar: t12,
      handleSearchBarFocus: t13,
      ...t14
    } = t0;
    advanced = t3;
    forPage = t4;
    index = t5;
    t1 = t6;
    isActive = t7;
    t2 = t8;
    variant = t9;
    initialQueryValue = t10;
    setSearchStateQuery = t11;
    toggleMobileSearchBar = t12;
    handleSearchBarFocus = t13;
    otherProps = t14;
    $[0] = t0;
    $[1] = advanced;
    $[2] = forPage;
    $[3] = handleSearchBarFocus;
    $[4] = index;
    $[5] = initialQueryValue;
    $[6] = isActive;
    $[7] = otherProps;
    $[8] = setSearchStateQuery;
    $[9] = t1;
    $[10] = t2;
    $[11] = toggleMobileSearchBar;
    $[12] = variant;
  } else {
    advanced = $[1];
    forPage = $[2];
    handleSearchBarFocus = $[3];
    index = $[4];
    initialQueryValue = $[5];
    isActive = $[6];
    otherProps = $[7];
    setSearchStateQuery = $[8];
    t1 = $[9];
    t2 = $[10];
    toggleMobileSearchBar = $[11];
    variant = $[12];
  }
  const inMobileNav = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? DEFAULT_SEARCH_PLACEHOLDER : t2;
  const history = useHistory();
  const currentPage = useUserCurrentPageType();
  const [searchQuery, updateSearchQuery] = useState(initialQueryValue || "");
  const {
    query: searchBoxQuery
  } = useSearchBox();
  const {
    isMobile
  } = useScreen();
  const isBrowser = useIsBrowser();
  let t3;
  if ($[13] !== isBrowser || $[14] !== setSearchStateQuery) {
    t3 = debounce(updatedValue => {
      if (isBrowser && setSearchStateQuery) {
        setSearchStateQuery(updatedValue);
      }
    }, SEARCH_STATE_UPDATE_DEBOUNCE_MS);
    $[13] = isBrowser;
    $[14] = setSearchStateQuery;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const debouncedSearchStateQueryUpdate = t3;
  let t4;
  if ($[16] !== debouncedSearchStateQueryUpdate) {
    t4 = event => {
      const {
        value
      } = event.target;
      updateSearchQuery(value);
      debouncedSearchStateQueryUpdate(value);
    };
    $[16] = debouncedSearchStateQueryUpdate;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const handleQueryChange = t4;
  let t5;
  if ($[18] !== advanced || $[19] !== currentPage || $[20] !== history || $[21] !== index || $[22] !== isBrowser || $[23] !== otherProps || $[24] !== searchBoxQuery || $[25] !== searchQuery) {
    t5 = () => {
      if (isBrowser) {
        const queryToUse = advanced ? searchQuery : searchBoxQuery;
        avo.productsSearched({
          query: queryToUse,
          location: currentPage,
          searchTarget: avo.SearchTarget.FULL_RESULTS
        });
        const newUrl = getAdvancedSearchUrlForQueryAndIndex(queryToUse, index || ALGOLIA_INDEX_NAME.PRODUCTS, ALL_FACETS_FILTER);
        history.push(newUrl, {
          instantQuery: queryToUse
        });
        otherProps?.toggleSearchOpen();
      }
    };
    $[18] = advanced;
    $[19] = currentPage;
    $[20] = history;
    $[21] = index;
    $[22] = isBrowser;
    $[23] = otherProps;
    $[24] = searchBoxQuery;
    $[25] = searchQuery;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  const goToAdvancedSearch = t5;
  let t6;
  if ($[27] !== currentPage || $[28] !== forPage || $[29] !== history || $[30] !== index || $[31] !== isMobile || $[32] !== otherProps) {
    t6 = e => {
      if (isMobile) {
        updateSearchQuery(e.currentTarget.value);
        if (otherProps.setSearchEventParams) {
          otherProps.setSearchEventParams({
            searchQuery: e.currentTarget.value,
            currentPage
          });
        }
        return;
      }
      if (forPage !== "associate" && (e.key === "Enter" || e.keyCode === 13) && e.target.value !== "" && isClient()) {
        const quickLinkMatch = getQuickLinkMatch(e.target.value);
        if (quickLinkMatch) {
          avo.productsSearched({
            query: e.target.value,
            location: currentPage,
            searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
          });
          history.push(quickLinkMatch.url);
          otherProps?.toggleSearchOpen();
          return;
        }
        avo.productsSearched({
          query: e.target.value,
          location: currentPage,
          searchTarget: avo.SearchTarget.FULL_RESULTS
        });
        const newUrl_0 = getAdvancedSearchUrlForQueryAndIndex(e.target.value, index || ALGOLIA_INDEX_NAME.PRODUCTS, ALL_FACETS_FILTER);
        history.push(newUrl_0, {
          instantQuery: e.target.value
        });
        otherProps?.toggleSearchOpen();
      }
    };
    $[27] = currentPage;
    $[28] = forPage;
    $[29] = history;
    $[30] = index;
    $[31] = isMobile;
    $[32] = otherProps;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  const handleKeyDown = t6;
  const t7 = variant === "ConsumerInstantSearch";
  let t8;
  if ($[34] !== t7) {
    t8 = classNames("[&_i]:w-[18px] [&_i]:h-[18px] [&_i]:text-[18px] [&_i]:block [&_i]:absolute [&_i]:top-1/2 [&_i]:mt-[-9px] [&_i]:right-10 [&_i]:cursor-pointer [&_i]:[border-right:1px_solid_#dfe0e1] bg-gray-light8", {
      "py-3": t7
    });
    $[34] = t7;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  const t9 = variant !== "ConsumerInstantSearch";
  const t10 = variant === "ConsumerInstantSearch";
  const t11 = variant === "ConsumerInstantSearch" && isActive;
  const t12 = variant === "InstantSearchMobile";
  let t13;
  if ($[36] !== inMobileNav || $[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t9) {
    t13 = classNames("mx-5 my-0 flex flex-row items-stretch relative box-border min-[1440px]:mx-[3.333vw] min-[1440px]:my-0", {
      "px-0 py-[5px]": t9,
      "!ml-3": inMobileNav,
      "px-3 bg-white rounded-[5px] border border-gray-light6 [&_.ais-SearchBox-input]:lg:!pl-0 [&_.ais-SearchBox-input]:lg:!text-left [&_.ais-SearchBox-input]:lg:!indent-[12px] [&_.ais-SearchBox-input::placeholder]:lg:!text-left [&_.ais-SearchBox-input.hasValue]:lg:!indent-[24px]": t10,
      "[&_button.ais-SearchBox-reset]:!block": t11,
      "[&_.ais-SearchBox-input]:indent-[12px]": t12
    });
    $[36] = inMobileNav;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t9;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  const t14 = variant === "InstantSearchMobile";
  let t15;
  if ($[42] !== t14) {
    t15 = classNames("self-center min-w-[16px]", {
      hidden: t14
    });
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t15) {
    t16 = <IconSearch className={t15} width={18} height={18} />;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== advanced || $[47] !== handleKeyDown || $[48] !== handleQueryChange || $[49] !== placeholder || $[50] !== searchQuery) {
    t17 = advanced && <div className="inline-flex w-full pl-2"><div className="flex w-full"><input className="text-left pl-[30px] [appearance:unset] bg-none [background:none] border-[1px] border-solid border-transparent text-[#333] block [font-size:1rem] font-bold h-10 leading-[1.45rem] tracking-[-.0125rem] w-full" type="search" placeholder={placeholder} autoComplete="off" autoCapitalize="off" spellCheck={false} maxLength={SEARCH_INPUT_MAX_LENGTH} value={searchQuery} onChange={handleQueryChange} onKeyDown={handleKeyDown} /></div></div>;
    $[46] = advanced;
    $[47] = handleKeyDown;
    $[48] = handleQueryChange;
    $[49] = placeholder;
    $[50] = searchQuery;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== advanced || $[53] !== handleKeyDown || $[54] !== handleSearchBarFocus || $[55] !== placeholder) {
    t18 = !advanced && <div className="inline-flex w-full" onClick={handleSearchBarFocus} role="button" tabIndex={0}><SearchBox placeholder={placeholder} onKeyDown={handleKeyDown} /></div>;
    $[52] = advanced;
    $[53] = handleKeyDown;
    $[54] = handleSearchBarFocus;
    $[55] = placeholder;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== goToAdvancedSearch || $[58] !== isBrowser || $[59] !== toggleMobileSearchBar || $[60] !== variant) {
    t19 = isBrowser && variant === "InstantSearchMobile" && <div className="flex gap-2 items-center"><IconSearch className="self-center min-w-[16px] cursor-pointer" width={18} height={18} onClick={goToAdvancedSearch} /><div className="text-gray">|</div><IconClose className="self-center min-w-[16px] cursor-pointer" width={14} height={14} color="#424242" onClick={toggleMobileSearchBar} /></div>;
    $[57] = goToAdvancedSearch;
    $[58] = isBrowser;
    $[59] = toggleMobileSearchBar;
    $[60] = variant;
    $[61] = t19;
  } else {
    t19 = $[61];
  }
  let t20;
  if ($[62] !== t13 || $[63] !== t16 || $[64] !== t17 || $[65] !== t18 || $[66] !== t19) {
    t20 = <div className={t13}>{t16}{t17}{t18}{t19}</div>;
    $[62] = t13;
    $[63] = t16;
    $[64] = t17;
    $[65] = t18;
    $[66] = t19;
    $[67] = t20;
  } else {
    t20 = $[67];
  }
  let t21;
  if ($[68] !== isActive || $[69] !== isMobile || $[70] !== variant) {
    t21 = isMobile && <div className={classNames("h-0 w-0 top-[65px] z-[-1] left-0 fixed bg-white [transition:opacity_.3s_ease-out] opacity-0 lg:absolute lg:bg-transparent", {
      active: isActive,
      hidden: variant === "InstantSearchMobile",
      "lg:opacity-100 lg:h-screen lg:w-screen lg:top-[-100px] lg:absolute lg:[transition:opacity_.3s_ease-out]": isActive
    })} />;
    $[68] = isActive;
    $[69] = isMobile;
    $[70] = variant;
    $[71] = t21;
  } else {
    t21 = $[71];
  }
  let t22;
  if ($[72] !== t20 || $[73] !== t21 || $[74] !== t8) {
    t22 = <div className={t8}>{t20}{t21}</div>;
    $[72] = t20;
    $[73] = t21;
    $[74] = t8;
    $[75] = t22;
  } else {
    t22 = $[75];
  }
  return t22;
};
export default JBSearchBoxNext;